export default {
  'userDevices.title': 'Dispositivos',
  'userDevices.user': 'Usuario',
  'userDevices.statusColumn': 'Estado',
  'userDevices.status.enabled': 'Habilitado',
  'userDevices.status.disabled': 'Deshabilitado',
  'userDevices.lastLogin': 'Último acceso',
  'userDevices.name': 'Nombre',
  'userDevices.platform': 'Plataforma',
  'userDevices.country': 'País',
  'userDevices.application': 'Aplicación',
  'userDevices.region': 'Región',
  'userDevices.state': 'Estado / Provincia',
  'userDevices.userAgent': 'Agente',
  'userDevices.action.lock': 'Bloquear',
  'userDevices.action.unlock': 'Desbloquear',

  'userDevices.platformType.unknown': 'Desconocido',
  'userDevices.platformType.generic': 'Genérico',
  'userDevices.platformType.windows': 'Windows',
  'userDevices.platformType.linux': 'Linux',
  'userDevices.platformType.unix': 'Unix',
  'userDevices.platformType.ios': 'Apple iOS',
  'userDevices.platformType.macOs': 'macOS',
  'userDevices.platformType.blackBerry': 'BlackBerry',
  'userDevices.platformType.android': 'Android',
  'userDevices.platformType.symbian': 'Symbian',
};
